import Vue from 'vue';
import jdenticon from 'jdenticon';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import io from 'socket.io-client';
// import Socketiop2p from 'socket.io-p2p';
// const P2P = require('socket.io-p2p');

import { getPhrase } from './dicer.js';
import UUID5 from 'uuid/v5';
import moment from 'moment';

const defaultNamespace = 'ebc3d3bc-9d99-4201-9b72-1ce368e43dde';

let socket = null;

jdenticon.config = {
	hues: [251],
	lightness: {
		color: [0.4, 0.8],
		grayscale: [0.3, 0.9]
	},
	saturation: {
		color: 0.5,
		grayscale: 0.0
	},
	backColor: '#a5212100'
};

const innerState = {
	typing: {
		/*
		conversationId: [...userIds]
		*/
	}
};

const state = {
	name: 'thunderwaveServer',
	socket: socket,
	curUser: null,
	conversations: {
		/*
		id: {
			providerName,
			id,
			name,
			'messagekeys': [...keys],
			lastMessage,
			'typing': [
				...{
					userId,
					userName*
				}
			],
			desc,
			owner: {
				userId,
				userName
			},
			totalPages,
			page
		}
		*/
	},
	messages: {
		/*
		key: {
			providerName,
			conversationId,
			key,
			userId,
			userName*,
			dateAdded,
			body
		}
		*/
	}
};

const getters = {
	isAvailable: () => {
		return true;
	},

	isReady: (state, getters) => {
		return getters.isLoggedIn;
	},

	conversationExists: ({ conversations }) => conversationId => {
		return conversations.hasOwnProperty(conversationId);
	},

	getCurUser({ curUser }) {
		return curUser;
	},

	isLoggedIn({ curUser }) {
		return !!curUser;
	},

	getUserAvatar: () => userId => {
		/*
		can return:
			0: no avatar
			1: default avatar system
			[2, Image]: image avatar (for canvas)
			[3, HTML]: html avatar
		*/
		// return 0;
		// return 1;
		return [
			3,
			jdenticon.toSvg(
				UUID5(userId, UUID5('userId', defaultNamespace)),
				48
			)
		];
	},

	getConversationAvatar: () => conversationId => {
		/*
		can return:
			0: no avatar
			1: default avatar system
			[2, Image]: image avatar (for canvas)
			[3, HTML]: html avatar
		*/
		// return 0;
		// return 1;
		return [
			3,
			jdenticon.toSvg(
				UUID5(
					conversationId,
					UUID5('conversationId', defaultNamespace)
				),
				48
			)
		];
	},

	getCurTyping: state => conversationId => {
		if (state.conversations.hasOwnProperty(conversationId)) {
			return state.conversations[conversationId].typing;
		}
		return null;
	},

	validateMessage: () => (messageBody, conversationId) => {
		return !!messageBody.trim();
	},

	managerComponent: (state, getters) => {
		return Vue.component(state.name + '-managerComponent', {
			data() {
				let rtrn = {
					userName: '',
					userId: '',
					serverAddress: 'https://chat.mcsanthy.de/',
					usePhraseAsId: true,
					conversationId: '',
					conversationIdWordNr: 3
				};
				return rtrn;
			},
			mounted() {
				this.genPhrase();

				this.$nextTick(() => {
					if (this.isLoggedIn) {
						this.userName = state.curUser.userName;
					} else {
						this.userName = getPhrase(1);
					}
				});
			},
			computed: {
				logInCheck() {
					return (
						this.userName &&
						this.userId &&
						this.serverAddress &&
						this.userId.length === 36 &&
						this.userName.length > 0 &&
						this.userName.length <= 32
					);
				},
				isLoggedIn() {
					return getters.isLoggedIn;
				},
				socketId() {
					return state.curUser && socket ? socket.id : '';
				},
				alreadyInConversation() {
					return getters.conversationExists(this.conversationId);
				},
				...mapGetters({
					state_curConversation:
						'ConversationProviders/state_curConversation'
				})
			},
			methods: {
				logIn() {
					this.userName = this.userName.trim();
					this.$nextTick(() => {
						if (this.logInCheck) {
							let nUser = {
								userId: this.userId,
								userName: this.userName
							};

							this.logInToProvider([nUser, this.serverAddress]);
						}
					});
				},
				logOut() {
					if (
						this.state_curConversation.providerName === state.name
					) {
						this.changeConversation([null, null]);
					}
					this.logOutFromProvider();
				},
				joinConversation() {
					if (this.conversationId) {
						socket.emit('joinConversation', this.conversationId);
					}
				},
				leaveConversation() {
					if (this.conversationId) {
						socket.emit('leaveConversation', this.conversationId);
					}
				},
				increaseconversationIdWordNr() {
					if (this.conversationIdWordNr < 25) {
						this.conversationIdWordNr++;
						this.genPhrase();
					}
				},
				decreaseconversationIdWordNr() {
					if (this.conversationIdWordNr > 1) {
						this.conversationIdWordNr--;
						this.genPhrase();
					}
				},
				genPhrase() {
					this.conversationId = getPhrase(this.conversationIdWordNr);
				},
				...mapMutations({
					changeConversation:
						'ConversationProviders/changeConversation'
				}),
				...mapActions({
					logInToProvider:
						'ConversationProviders/provider_' +
						state.name +
						'/logIn',
					logOutFromProvider:
						'ConversationProviders/provider_' +
						state.name +
						'/logOut'
				})
			},
			watch: {
				userName(newval, oldval) {
					if (newval.length > 32) {
						this.userName = oldval;
					} else if (newval.length > 0) {
						this.userId = UUID5(newval, defaultNamespace);
					}
				}
			},
			template: `
			<div class="manager-component">
				<h4 style="margin-top: 0;">Server and user</h4>
				<input class="server-address input" v-model="serverAddress" :readonly="isLoggedIn == true" placeholder="server address" title="server address" />
				<br />
				<div class="input-group">
					<span class="input-group-addon">user name</span>
					<input class="user-name input" v-model="userName" :readonly="isLoggedIn == true" placeholder="user name" title="user name" min="1" max="32" />
					<span v-if="isLoggedIn == false" class="input-group-addon">1-32 chars</span>
				</div>
				<div v-if="socketId" class="input-group" style="margin-top: .4rem;">
					<span class="input-group-addon">socket id</span>
					<input class="input" readonly="true" :value="socketId" title="socket id" />
				</div>
				<div class="btn-group" style="margin-top: .4rem;">
					<button v-if="isLoggedIn == false" type="submit" @click="logIn()" :disabled="!logInCheck" class="btn rounded lg primary"><i class="icon mdi mdi-login" style="bottom: 2px;"></i>&nbsp;Log in</button>
					<button v-else type="submit" @click="logOut()" class="btn flat rounded secondary"><i class="icon mdi mdi-logout" style="bottom: 1px;"></i>&nbsp;Log out</button>
				</div>
				<div v-if="isLoggedIn == true">
					<h4>Join and leave conversations</h4>
					<div class="input-group">
						<input class="conversation-id input" v-model="conversationId" placeholder="conversation id" title="conversation id" />
						<!--<input type="number" class="conversation-id-word-number input" v-model="conversationIdWordNr" min="1" max="25" />-->
						<button @click="genPhrase()" class="btn action flat outline secondary"><i class="icon mdi mdi-refresh"></i></button>
					</div>
					<div class="input-group inline" style="margin-top: .4rem;">
						<button @click="decreaseconversationIdWordNr()" class="btn action flat">-</button>
						<span class="input-group-addon">{{ conversationIdWordNr }} words</span>
						<button @click="increaseconversationIdWordNr()" class="btn action flat">+</button>
					</div>
					<br />
					<div class="btn-group" style="margin-top: .4rem;">
						<button v-if="!alreadyInConversation" type="submit" @click="joinConversation()" :disabled="!conversationId" class="btn rounded lg primary"><i class="icon mdi mdi-location-enter" style="bottom: 2px;"></i>&nbsp;Join Conversation</button>
						<button v-else type="submit" @click="leaveConversation()" class="btn flat outline rounded secondary"><i class="icon mdi mdi-location-exit" style="bottom: 1px;"></i>&nbsp;Leave Conversation</button>
					</div>
				</div>
			</div>
			`
		});
	},

	getConversationInfo: (state, getters) => conversationId => {
		if (getters.conversationExists(conversationId)) {
			return {
				id: conversationId,
				name: state.conversations[conversationId].name,
				desc: state.conversations[conversationId].desc,
				owner: state.conversations[conversationId].owner,
				nrOfMessages:
					state.conversations[conversationId].messagekeys.length
			};
		}
		return null;
	},

	conversationInfoComponent: (state, getters) => conversationId => {
		return Vue.component(state.name + '-conversationInfoComponent', {
			data() {
				return {
					editing: false,
					editName: '',
					editDesc: ''
				};
			},
			mounted() {
				this.$nextTick(() => {
					this.getConversationInfo(this.conversationId);
				});
			},
			computed: {
				conversationId() {
					return conversationId;
				},
				info() {
					return this.conversationInfo(this.conversationId);
				},
				...mapGetters({
					conversationInfo:
						'ConversationProviders/provider_' +
						state.name +
						'/getConversationInfo',
					curUser:
						'ConversationProviders/provider_' +
						state.name +
						'/getCurUser'
				})
			},
			methods: {
				leaveConversation() {
					socket.emit('leaveConversation', this.conversationId);
				},
				claimRoom() {
					socket.emit('claimRoom', this.conversationId);
				},
				openEdit() {
					this.editName = this.info.name;
					this.editDesc = this.info.desc;

					this.editing = true;
				},
				saveEdit() {
					socket.emit(
						'setRoomInfo',
						this.conversationId,
						this.editName,
						this.editDesc
					);

					this.editing = false;
				},
				discardEdit() {
					this.editName = this.info.name;
					this.editDesc = this.info.desc;

					this.editing = false;
				},
				...mapActions({
					getConversationInfo:
						'ConversationProviders/provider_' +
						state.name +
						'/getConversationInfo'
				})
			},
			watch: {
				info(newval) {
					this.editName = newval.name;
					this.editDesc = newval.desc;
				}
			},
			template: `
			<div class="conversationInfo-component">
				<div>
					<button v-if="info && info.owner.userId === null" type="submit" @click="claimRoom()" class="btn lg rounded primary" style="margin: 0 auto; display: block;"><i class="icon mdi mdi-crown" style="bottom: 2px;"></i>&nbsp;Claim Conversation</button>
					<div v-else-if="info && info.owner.userId === curUser.userId">
						<div v-if="editing">
							<div class="input-group">
								<input class="input" v-model="editName" placeholder="conversation name" title="conversation name" />
							</div>
							<div class="input-group" style="margin-top: .4rem;">
								<textarea class="input" v-model="editDesc" placeholder="conversation description" title="conversation description"></textarea>
							</div>
							<div class="btn-group btn-group-block" style="margin-top: 1.2rem; display: flex;">
								<button @click="saveEdit()" class="btn flat secondary">Save details</button>
								<button @click="discardEdit()" class="btn flat">Discard changes</button>
							</div>
						</div>
						<button v-else @click="openEdit()" class="btn rounded secondary" style="margin: 0 auto; display: block;"><i class="icon mdi mdi-circle-edit-outline" style="bottom: 1px;"></i>&nbsp;Edit details</button>
					</div>
				</div>
				<template v-if="info && !editing">
					<p><b class="clr-secondary" style="margin: 0;">Number of messages:&nbsp;</b>{{ info.nrOfMessages }}</p>
					<div class="card">
						<b class="clr-secondary" style="margin: 0;">Description</b>
						<p v-if="info.desc" style="margin-bottom: 0;">{{ info.desc }}</p>
						<p v-else style="margin-bottom: 0;"><i>No description</i></p>
					</div>
					<div class="card">
						<b class="clr-secondary" style="margin: 0;">Conversation ID</b>
						<p v-if="info.id" style="margin-bottom: 0;">{{ info.id }}</p>
					</div>
					<div>
						<button type="submit" @click="leaveConversation()" class="btn flat outline rounded secondary" style="margin: 0 auto; display: block;"><i class="icon mdi mdi-location-exit" style="bottom: 1px;"></i>&nbsp;Leave Conversation</button>
					</div>
				</template>
			</div>
			`
		});
	},

	conversationListItemActions: (state, getters) => (
		conversationId,
		{ commit }
	) => {
		if (!getters.conversationExists(conversationId)) return null;

		// const conversation = state.conversations[conversationId];

		return [
			{
				name: 'Leave conversation',
				onclick: () => {
					commit(
						'ConversationProviders/provider_' +
							state.name +
							'/leaveConversation',
						conversationId
					);
				},
				classes: 'link secondary',
				conversationId
			}
		];
	},

	messageActions: (state, getters) => (message, { commit }) => {
		const conversationId = message.conversationId;

		if (!getters.conversationExists(conversationId)) return null;

		// const conversation = state.conversations[conversationId];

		return [
			{
				name: 'Delete message',
				onclick: () => {
					commit(
						'ConversationProviders/provider_' +
							state.name +
							'/deleteMessage',
						[conversationId, message.key]
					);
				},
				classes: 'link',
				conversationId
			}
		];
	}
};

const mutations = {
	logIn(state, nUser) {
		state.curUser = nUser;
	},

	logOut(state) {
		state.curUser = null;
	},

	addMessage(state, [conversationId, messageData]) {
		state.messages = {
			...state.messages,
			[messageData.key]: messageData
		};
		state.conversations = {
			...state.conversations,
			[conversationId]: {
				...state.conversations[conversationId],
				messagekeys:
					state.conversations[conversationId].messagekeys.indexOf(
						messageData.key
					) === -1
						? [
								...state.conversations[conversationId]
									.messagekeys,
								messageData.key
						  ]
						: [...state.conversations[conversationId].messagekeys],
				lastMessage: messageData
			}
		};
		return null;
	},

	deleteMessage(state, [conversationId, messagekey]) {
		delete state.messages[messagekey];
		state.messages = {
			...state.messages
		};
		if (state.conversations[conversationId]) {
			const index = state.conversations[
				conversationId
			].messagekeys.indexOf(messagekey);
			if (index !== -1) {
				let messagekeys = JSON.parse(
					JSON.stringify(
						state.conversations[conversationId].messagekeys
					)
				);
				messagekeys.splice(index, 1);

				state.conversations = {
					...state.conversations,
					[conversationId]: {
						...state.conversations[conversationId],
						messagekeys,
						lastMessage:
							messagekeys.length > 0
								? state.messages[
										messagekeys[messagekeys.length - 1]
								  ]
								: null
					}
				};
			}
		}
	},

	joinConversation(state, [conversationId, conversationName]) {
		conversationName = conversationName || conversationId;
		state.conversations = {
			...state.conversations,
			[conversationId]: {
				providerName: state.name,
				id: conversationId,
				name: conversationName,
				messagekeys: [],
				lastMessage: null,
				typing: [],
				desc: '',
				owner: {
					userId: null,
					userName: null
				},
				totalPages: 0,
				page: 0
			}
		};
	},

	leaveConversation(state, conversationId) {
		state.conversations[conversationId].messagekeys.map(
			messagekey => delete state.messages[messagekey]
		);

		delete state.conversations[conversationId];
		state.conversations = {
			...state.conversations
		};
	},

	setRoomInfo(state, [conversationId, info]) {
		if (state.conversations.hasOwnProperty(conversationId)) {
			state.conversations = {
				...state.conversations,
				[conversationId]: {
					...state.conversations[conversationId],
					...info
				}
			};
		}
	},

	setTyping(state, [conversationId, userId, userName, to]) {
		if (state.conversations.hasOwnProperty(conversationId)) {
			if (!innerState.typing.hasOwnProperty(conversationId)) {
				innerState.typing[conversationId] = [];
			}
			let index = innerState.typing[conversationId].indexOf(userId);
			if (to) {
				if (index === -1) {
					innerState.typing[conversationId].push(userId);
					state.conversations[conversationId].typing.push({
						userId,
						userName
					});
				}
			} else {
				if (index !== -1) {
					innerState.typing[conversationId].splice(index, 1);
					state.conversations[conversationId].typing.splice(index, 1);
				}
			}
			state.conversations = {
				...state.conversations
			};
		}
	},

	updateFetchMessages(state, [conversationId, totalPages, page, slice]) {
		if (state.conversations.hasOwnProperty(conversationId)) {
			let messagesData = {};

			for (let msgI = 0; msgI < slice.length; msgI++) {
				let msg = slice[msgI];
				messagesData[msg.key] = msg;
			}

			const nMessagekeys = Object.keys(messagesData);

			let nLastMessage = false;
			if (page === totalPages - 1) {
				nLastMessage =
					slice
						.sort((a, b) => {
							return moment(a.dateAdded, 'x').isBefore(
								moment(b.dateAdded, 'x')
							)
								? 1
								: -1;
						})
						.reverse()[0] || false;
			}

			state.conversations = {
				...state.conversations,
				[conversationId]: {
					...state.conversations[conversationId],
					totalPages,
					page
				}
			};

			state.messages = {
				...state.messages,
				...messagesData
			};
			state.conversations = {
				...state.conversations,
				[conversationId]: {
					...state.conversations[conversationId],
					messagekeys: [
						...new Set([
							...nMessagekeys,
							...state.conversations[conversationId].messagekeys
						])
					],
					lastMessage:
						nLastMessage ||
						state.conversations[conversationId].lastMessage
				}
			};
		}
	}
};

const actions = {
	init({ state }) {
		console.debug('initted conversation provider', state.name);
	},

	logIn({ commit, dispatch }, [nUser, serverAddress]) {
		console.debug('logging in to conversation provider', nUser);

		let defaultUser = {
			userId: String,
			userName: String
		};

		let validLogIn = true;

		for (let i in defaultUser) {
			if (!nUser.hasOwnProperty(i)) {
				console.debug("nUser doesn't have property", i);
				validLogIn = false;
				break;
			} else if (typeof nUser[i] !== typeof defaultUser[i]()) {
				console.debug(
					'nUser typeof',
					i,
					'not matching required',
					typeof nUser[i],
					typeof defaultUser[i]
				);
				validLogIn = false;
				break;
			} else if (!nUser[i]) {
				validLogIn = false;
				break;
			} else {
				defaultUser[i] = nUser[i];
			}
		}

		console.debug('validLogIn', validLogIn);

		if (validLogIn) {
			if (socket) {
				socket.disconnect();
				socket = null;
			}

			socket = io(serverAddress, {
				reconnectionAttempts: 3
			});

			socket.on('reconnect_failed', () => {
				socket.disconnect();
				socket = null;
			});

			socket.once('logInValidation', (valid, socketId) => {
				if (valid) {
					commit('logIn', defaultUser);
					socket.emit('joinConversation', socketId);
					socket.emit(
						'joinConversation',
						'b07c302a-836e-49c0-9d31-6485a776913d'
					);
				} else {
					socket.disconnect();
					socket = null;
				}
			});

			socket.on(
				'joinedConversation',
				(conversationId, conversationName) => {
					console.debug('joinedConversation', conversationId);
					commit('joinConversation', [
						conversationId,
						conversationName
					]);
					socket.emit('getRoomInfo', conversationId);
					socket.emit('fetchMessages', conversationId);
				}
			);
			socket.on('leftConversation', conversationId => {
				console.debug('leftConversation', conversationId);
				commit('leaveConversation', conversationId);
			});

			socket.on('claimedRoom', conversationId => {
				console.debug('claimedRoom', conversationId);
			});

			socket.on('roomInfo', (conversationId, info) => {
				console.debug('roomInfo', conversationId, info);
				commit('setRoomInfo', [conversationId, info]);
			});

			socket.on('addMessage', messageData => {
				// console.debug('addMessage', messageData);
				dispatch('addMessage', [
					messageData.conversationId,
					messageData.userId,
					messageData.userName,
					messageData.key,
					messageData.dateAdded,
					messageData.body
				]);
			});

			socket.on('updateTyping', data => {
				commit('setTyping', [
					data.conversationId,
					data.userId,
					data.userName,
					data.to
				]);
			});

			socket.on(
				'fetchedMessages',
				(conversationId, totalPages, page, slice) => {
					console.debug(
						'fetchedMessages',
						conversationId,
						totalPages,
						page,
						slice
					);

					commit('updateFetchMessages', [
						conversationId,
						totalPages,
						page,
						slice
					]);
				}
			);

			socket.emit('logIn', defaultUser);

			// const opts = {
			//     peerOpts: {
			//         trickle: false
			//     },
			//     autoUpgrade: false
			// };
			// const p2p = new P2P(socket, opts, () => {
			//     console.debug('p2p initted');
			//     p2p.emit('hi, I\'m ' + p2p.peerId);
			// });

			// p2p.on('ready', function () {
			//     console.debug('p2p ready');
			//     // p2p.usePeerConnection = true;
			//     // p2p.emit('peer-obj', { peerId: peerId });
			// });

			// this event will be triggered over the socket transport
			// until `usePeerConnection` is set to `true`
			// p2p.on('peer-msg', function (data) {
			//     console.log(data);
			// });
		}
	},

	logOut({ commit }) {
		if (socket) {
			socket.emit('logOut');
			socket.disconnect();
			socket = null;
		}
		commit('logOut');
	},

	addMessage(
		{ state, getters, commit },
		[conversationId, userId, userName, msgUUID, dateAdded, messageBody]
	) {
		if (getters.conversationExists(conversationId)) {
			let messageData = {
				providerName: state.name,
				conversationId: conversationId,
				key: msgUUID,
				userId: userId,
				userName: userName,
				dateAdded: dateAdded,
				body: messageBody
			};

			commit('addMessage', [conversationId, messageData]);

			return messageData;
		} else {
			console.debug(
				'provider',
				state.name,
				'has no conversation with id',
				conversationId
			);
			return null;
		}
	},

	sendMessage({ getters }, [conversationId, messageBody]) {
		if (getters.isLoggedIn) {
			if (getters.validateMessage(messageBody, conversationId)) {
				console.debug(
					'provider sending message..',
					conversationId,
					messageBody
				);

				// send message to other peers
				socket.emit('sendMessage', conversationId, messageBody);

				return true;
			}
			throw new Error('Message invalid!');
		}
		throw new Error('Not logged in!');
	},

	updateTyping({ state }, [conversationId, to = false]) {
		if (conversationId) {
			socket.emit('updateTyping', conversationId, to);
		}
	},

	getConversationInfo({ state }, conversationId) {
		if (conversationId) {
			socket.emit('getRoomInfo', conversationId);
		}
	},

	fetchMessages({ state, getters, commit }, conversationId) {
		return new Promise((resolve, reject) => {
			if (conversationId) {
				if (getters.conversationExists(conversationId)) {
					const totalPages =
						state.conversations[conversationId].totalPages;
					const page = state.conversations[conversationId].page - 1;

					if (page >= 0) {
						// commit('updateFetchMessages', [conversationId, totalPages, page]);
						socket.emit(
							'fetchMessages',
							conversationId,
							page,
							16,
							function({
								conversationId: _conversationId,
								page: _page,
								perPage: _perPage,
								totalPages: _totalPages,
								slice: _slice
							}) {
								console.debug(
									'fetchMessages cb',
									conversationId,
									totalPages,
									page,
									_conversationId,
									_page,
									_perPage,
									_totalPages,
									_slice
								);

								commit('updateFetchMessages', [
									_conversationId,
									_totalPages,
									_page,
									_slice
								]);

								resolve({
									conversationId: _conversationId,
									totalPages: _totalPages,
									page: _page,
									slice: _slice
								});
							}
						);
					} else {
						resolve({
							conversationId,
							totalPages,
							page,
							slice: []
						});
					}
				}
			}
		});
	}
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
